import React, { useState } from 'react';
import {
  TextField, makeStyles, InputAdornment, Hidden,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import PlaceRenderedOption from 'views/motorcycle_rental/components/widget/PlaceRenderedOption';
import { withTranslation } from 'config/i18n';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import CloseIcon from '@material-ui/icons/Close';
import LocationOnIcon from '@material-ui/icons/LocationOn';

const useStyles = makeStyles((theme) => ({
  dropoffAutocomplete: {
    minWidth: theme.spacing(29),
    height: '100%',
    [theme.breakpoints.up('xl')]: {
      minWidth: theme.spacing(31),
    },
  },
  textFieldRootOverride: {
    height: '100%',
    '& input': {
      '&::placeholder': {
        color: 'black',
        opacity: '0.8',
      },
    },
    '& .MuiInputLabel-formControl': {
      left: theme.spacing(4.5),
      [theme.breakpoints.up('lg')]: {
        top: theme.spacing(2),
      },
    },
  },
  inputBaseRootOverride: {
    height: '100%',
    fontSize: theme.typography.pxToRem(14),
    paddingRight: `${theme.spacing(1)} !important`,
    '&::before': {
      borderBottom: '0',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  adornmentIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  adornmentCloseIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    cursor: 'pointer',
  },
}));

const SearchDropoff = ({ t, data }) => {
  const classes = useStyles();
  const {
    dropoffGeos, selectedDropoffGeo, onDropoffChange, onClearDropoff, variant,
  } = data;

  const [inputValue, setInputValue] = useState('');

  // check if there is a value to add to the array if not create empty array
  const getOptions = () => {
    if (dropoffGeos) {
      return [...dropoffGeos];
    }
    if (selectedDropoffGeo) {
      return [selectedDropoffGeo];
    }
    return [];
  };

  // here setOptions remove because of ESlint
  const [options] = useState(getOptions());

  return (
    <>
      <Autocomplete
        freeSolo
        id="dropoff"
        className={classes.dropoffAutocomplete}
        options={options}
        getOptionLabel={(option) => option.name || option.display_name} // this is name on the old env! but in th eprototype it's large_label
        // to render custom options
        renderOption={(option) => <PlaceRenderedOption option={option} />}
        getOptionSelected={(option, value) => option.name == value.name}
        value={selectedDropoffGeo || null}
        onChange={(e, value) => onDropoffChange(value)}
        inputValue={inputValue}
        onInputChange={(e, value) => setInputValue(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t('fe_es_geo_widget:place.dropoff')}
            placeholder={t('fe_es_geo_widget:place.dropoff_label')}
            variant={variant}
            classes={{
              root: classes.textFieldRootOverride,
            }}
            InputProps={{
              ...params.InputProps,
              classes: {
                root: classes.inputBaseRootOverride,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Hidden mdDown>
                    <ArrowRightAltIcon className={`${classes.adornmentIcon} arrowIconOverride`} />
                  </Hidden>
                  <Hidden lgUp>
                    <LocationOnIcon className={classes.adornmentIcon} />
                  </Hidden>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <CloseIcon className={classes.adornmentCloseIcon} onClick={onClearDropoff} />
                </InputAdornment>
              ),
            }}
          />
        )}
        // filterOptions={(optionsArr) => optionsArr}
      />
    </>
  );
};
export default withTranslation(['fe_es_geo_widget'])(SearchDropoff);
